var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ingredients"},[_c('h4',[_vm._v("Ingredients")]),_vm._v(" "),_c('div',{staticClass:"ingredientObjects"},_vm._l((_vm.objects),function(object){return _c('ObjectImage',{key:object.id,staticClass:"ingredientObject",attrs:{"hover":"true","clickable":"true","object":object,"uses":_vm.ingredientUses(object)}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1495ed5a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecipeIngredients.vue
// module id = 91
// module chunks = 0